import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase"; // db 가져오기
import { doc, getDoc } from "firebase/firestore"; // Firestore 관련 함수 가져오기
import "./Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Firestore에서 사용자 닉네임 가져오기
      const userDoc = await getDoc(doc(db, "users", user.uid));
      if (userDoc.exists()) {
        const userData = userDoc.data();
        console.log("로그인한 유저 닉네임:", userData.nickname); // 필요한 경우 닉네임 활용 가능
      }

      alert("로그인 성공!");
      navigate("/"); // 이전 페이지로 이동
    } catch (err) {
      console.error("로그인 실패:", err);
      setError("로그인에 실패했습니다. 이메일과 비밀번호를 확인하세요.");
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>로그인</h1>
        {error && <p className="login-error">{error}</p>}
        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="이메일"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="login-input"
            required
          />
          <input
            type="password"
            placeholder="비밀번호"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="login-input"
            required
          />
          <button type="submit" className="login-button">
            로그인
          </button>
        </form>
        <p className="signup-text">
          계정이 없으신가요?{" "}
          <button
            className="signup-button"
            onClick={() => navigate("/signup")}
          >
            회원가입
          </button>
        </p>
      </div>
    </div>
  );
};

export default Login;